import { api } from "./axios";
import { apiUrl } from "../config/backendFeatures";

/*
 * Site → CRM intake (turaq-backend docs/CRM.md, POST /api/v2/leads).
 * Fire-and-forget from phone reveal / WhatsApp / chat start / request forms.
 * Resolves `true` when the server took it, `false` while CRM is off (404) or
 * on any error — it never blocks the user action it accompanies.
 */

export type LeadSource = "phone_reveal" | "whatsapp_click" | "chat" | "request" | "collection";

export interface LeadInput {
  source: LeadSource;
  property_id?: number;
  complex_id?: number;
  unit_id?: number;
  profile_id?: number;
  name?: string;
  phone?: string;
  comment?: string;
  budget?: number;
  currency?: "USD" | "KGS";
}

/** Same lead twice in a row (e.g. two clicks) is sent once per page session. */
const sent = new Set<string>();

export async function postLead(input: LeadInput): Promise<boolean> {
  const key = JSON.stringify([input.source, input.property_id, input.complex_id, input.unit_id, input.profile_id, input.comment]);
  if (sent.has(key) && input.source !== "request") return true;
  try {
    const body = Object.fromEntries(Object.entries(input).filter(([, v]) => v !== undefined && v !== ""));
    if (body.phone) body.phone = String(body.phone).replace(/[^\d+]/g, "");
    const { data } = await api.post(apiUrl("/api/v2/leads"), body);
    sent.add(key);
    return !!data?.ok;
  } catch {
    return false;
  }
}
